module.exports = __webpack_public_path__ + "static/media/header_conapred_articuli.be4cf440.png";